exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".profile-view{background:#fff}.profile-view .profil{margin-top:0;padding-top:60px}.profile-view .uploader{border-radius:100px;margin-left:auto;margin-right:auto;cursor:pointer;width:128px;height:128px}.profile-view .add{position:relative;bottom:28px;left:102px}.profile-view #file-input{display:none}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/js/views/ProfileView/ProfileView.less
 ** module id = 518
 ** module chunks = 1
 **/